import { v4 } from 'uuid';
import { assertValued } from './util';
export class UserService {
    constructor(userRemoteRepository) {
        this.userRemoteRepository = userRemoteRepository;
    }
    async fetchUsers() {
        return await this.userRemoteRepository.fetchUsers();
    }
    async unblockUser(userId) {
        return await this.userRemoteRepository.unblockUser(userId);
    }
    async deleteUser(userId) {
        return await this.userRemoteRepository.deleteUser(userId);
    }
    async createUser() {
        const dialogUserSaveRequest = {
            id: v4(),
            username: '',
            password: '',
            currentPassword: '',
            operator: true,
            intervisor: false
        };
        const userToSave = await this.userCreateDialog.open(dialogUserSaveRequest);
        await this.userRemoteRepository.saveUser(userToSave);
    }
    async editUser(user) {
        const dialogUserSaveRequest = {
            id: user.id,
            username: user.username,
            password: '',
            currentPassword: '',
            operator: user.operator,
            intervisor: user.intervisor
        };
        const userToSave = await this.userEditDialog.open(dialogUserSaveRequest);
        await this.userRemoteRepository.saveUser(userToSave);
    }
    async editMySessionUserPassword() {
        const user = await this.userRemoteRepository.getCurrentAuthUser();
        const dialogUserSaveRequest = {
            id: user.id,
            username: user.username,
            password: '',
            currentPassword: '',
            operator: user.operator,
            intervisor: user.intervisor
        };
        const userToSave = await this.userPasswordEditDialog.open(dialogUserSaveRequest);
        const userPasswordSaveRequest = {
            id: userToSave.id,
            currentPassword: assertValued(userToSave.currentPassword),
            password: assertValued(userToSave.password),
        };
        return await this.userRemoteRepository.saveUserPassword(userPasswordSaveRequest);
    }
    async registerUserPasswordEditDialog(userPasswordEditDialog) {
        this.userPasswordEditDialog = userPasswordEditDialog;
    }
    async registerUserEditDialog(userEditDialog) {
        this.userEditDialog = userEditDialog;
    }
    async registerUserCreateDialog(userCreateDialog) {
        this.userCreateDialog = userCreateDialog;
    }
}
